export const rootStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  paddingX: 1,
  paddingY: 0.25,
  marginBottom: 0.5,
  borderLeftWidth: 2,
  borderLeftStyle: 'solid',
  borderLeftColor: theme => theme.palette.primary.main,
  backgroundColor: theme => theme.palette.action.hover,
  color: theme => theme.palette.text.secondary,
  cursor: 'pointer',
  borderRadius: 0.5,
  maxWidth: '100%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};
